import { useLayoutEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sortByOrder } from 'utils/collection-manipulation/array-sort-by';
import { EIconSize } from 'utils/constants/app/ui';
import { sports } from 'utils/constants/sportsbook/data-fields';
import RidGenerator from 'utils/swarm/rid-generator';
import { Sport } from 'interfaces/sportsbook-data-levels';
import { executeCommand } from 'services/get-data-level';
import { LiveCompetitionsCollapse } from 'newelements/Sportsbook/layouts/advanced/Desktop/__partials/AdvancedLiveGamesList/LiveCompetitionsCollapse';
import { AdvancedLiveGamesListSkeleton } from 'newelements/Sportsbook/layouts/advanced/Desktop/__partials/AdvancedLiveGamesList/Skeleton';
import { GlobalIcon } from 'components/GlobalIcon';
import { NavigationCollapse } from 'components/NavigationCollapse';
import { useGetUserSportOrder } from 'hooks/sportsbook/useGetUserSportOrder';
import { useMounted } from 'hooks/useMounted';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import { setAdvancedLiveSports } from 'store/actions/new-sportsbook';
import { getAdvancedLiveSports } from 'store/selectors/new-sportsbook';
import './index.less';

export const AdvancedLiveGamesList = () => {
  const dispatch = useDispatch();
  const { mounted } = useMounted();
  const { params } = useSbRouteMatch();

  const liveSportsData = useSelector(getAdvancedLiveSports);

  const { orderSports } = useGetUserSportOrder();

  const orderedSports = useMemo(() => {
    if (liveSportsData) {
      return orderSports(sortByOrder(Object.values(liveSportsData)));
    }

    return liveSportsData;
  }, [liveSportsData, orderSports]);

  useLayoutEffect(() => {
    const rId = RidGenerator.gForSubscribe(`ADVANCED_GET_LIVE_SPORTS`);

    const what = {
      ...sports,
      game: '@count'
    };

    const where = {
      game: { type: 1 }
    };

    const onResponse = (data: { sport: Record<string, Sport> }) => {
      if (data && data.sport && mounted.current) {
        dispatch(setAdvancedLiveSports(data.sport));
      }
    };

    executeCommand(rId, what, where, onResponse, true, onResponse);
  }, []);

  return orderedSports ? (
    <div className="advancedLiveGamesListWrapper">
      {orderedSports.map(sport => (
        <NavigationCollapse
          key={sport.id}
          defaultActive={params.sport === sport.alias}
          headerClassName="liveSportCollapseHeader"
          wrapperClassName="liveSportCollapseWrapper"
          icon={
            <GlobalIcon lib="sports" name={sport.alias} size={EIconSize._24} />
          }
          title={sport.name}
        >
          <LiveCompetitionsCollapse sportAlias={sport.alias} />
        </NavigationCollapse>
      ))}
    </div>
  ) : (
    <AdvancedLiveGamesListSkeleton />
  );
};
